import Card from "common/TourItem";
export default function TourOrdersTab() {
  return (
    <div class="tab-pane fade  " id="tour-orders">
      {[...Array(5)].map((value, index) => {
        return <Card index={index} type="order"></Card>;
      })}
    </div>
  );
}
